"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILE_VISIBILITY_HELP_LINK = void 0;
var FILE_VISIBILITY_HELP_LINK = 'https://knowledge.hubspot.com/cos-general/copy-and-update-the-url-of-files-uploaded-to-the-file-manager';
exports.FILE_VISIBILITY_HELP_LINK = FILE_VISIBILITY_HELP_LINK;